export const ADD_INSURANCE_ORIGIN_USER_PROFILE = 'up';
